import React from 'react';
import factory from '../assets/img/factory.jpg';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function HeroSection({ t, language }) {
    const isRTL = language === 'ar' || language === 'ku';

    return (
        <div className={`h-[60vh] md:h-[40vh] lg:h-[60vh] bg-cover overflow-hidden flex-row md:flex md:justify-between mt-14 md:mt-32 md:m-20 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <div className="rounded-tr-2xl overflow-hidden border-l-4 border-[#16423ccc] pl-2 h-fit md:w-full m-5 block md:hidden">
                <LazyLoadImage src={factory} alt="Factory" effect="blur" />
            </div>
            <div className={`text-black text-center md:mt-20 m-2 md:m-0  md:text-${isRTL ? 'end' : 'start'}`}>
                <div className="p-4 w-full">
                    <h1 className="text-[18px] md:text-5xl md:w-[600px] m-1">
                        {t('heroText')}
                    </h1>
                </div>
            </div>
            <div className={`rounded-tr-${isRTL ? '0' : '2xl'} overflow-hidden border-${isRTL ? 'r' : 'l'}-4 border-[#16423ccc] pl-${isRTL?'0':'2'} pr-${isRTL?'2':'0'} h-fit hidden md:block md:w-full ` }>
                <LazyLoadImage src={factory} alt="Factory" effect="blur" />
            </div>
        </div>
    );
}

export default HeroSection;
